import { type ExtrasOverview, ExtrasTypes } from "../../Extras/types";
import DesignerAssetCard from "components/cards/DesignerAssetCard/DesignerAssetCard";
import SectionHeaderIcon from "../../../../../../images/section-header-icon.svg?react";
import { Image } from "semantic-ui-react";
import FlowEndIcon from "../../../../../../images/flow-end-icon.png";
import DragNDropItemTypes from "enums/dragNDropItemTypes";

type Props = {
  item: ExtrasOverview;
  isDraggable: boolean;
};

export function ExtrasCard({ item, isDraggable }: Props) {
  if (item?.cardType === ExtrasTypes.SectionHeader)
    return (
      <DesignerAssetCard
        assetType={ExtrasTypes.SectionHeader}
        isDraggable={isDraggable}
        dragNDropItemType={DragNDropItemTypes.DESIGNER}
        thumbnailUrl={<SectionHeaderIcon />}
        dataHookType="flow-designer-section-header-card"
        {...item}
        title={"Section Header"}
        hideTitle
      />
    );
  if (item?.cardType === ExtrasTypes.FlowEnd)
    return (
      <DesignerAssetCard
        assetType={ExtrasTypes.FlowEnd}
        isDraggable={isDraggable}
        dragNDropItemType={DragNDropItemTypes.DESIGNER}
        dataHookType="flow-designer-flow-end"
        thumbnailUrl={<Image src={FlowEndIcon} draggable={false} />}
        {...item}
        title={"End of Flow"}
        hideTitle
      />
    );
  // add other cards here in the future
  return null;
}
